import { StatusBadge } from "@components/display/StatusBadge";
import { STATUT_TICKET } from "../../config/statuses";

interface TicketStatusBadgeProps {
  status: string;
  size?: "sm" | "md";
}

export function TicketStatusBadge({ status, size = "sm" }: TicketStatusBadgeProps) {
  return <StatusBadge status={status} config={STATUT_TICKET} size={size} />;
}
